import { Preferences } from '@capacitor/preferences'
import { LocalConfig, Tenant } from '@velociti/core'
import { IAuthStore } from 'src/system/core/model/auth/IAuthStore'

export interface IAppPreferences {
  get(key: string): Promise<unknown | null>
  set(key: string, value: unknown): Promise<void>
  getTenant(): Promise<Tenant | undefined>
  getApiUrl(): Promise<string | undefined>
  getAuthToken(): Promise<string | undefined>
}

export class AppPreferences implements IAppPreferences {
  async get(key: string) {
    const val = await Preferences.get({ key: key })
    return val && val.value ? JSON.parse(val.value) : null
  }

  async set(key: string, value: unknown) {
    return await Preferences.set({ key: key, value: JSON.stringify(value) })
  }

  async getTenant(): Promise<Tenant | undefined> {
    const config: LocalConfig | null = await this.get('config')
    return config?.tenant || undefined
  }

  async getApiUrl(): Promise<string | undefined> {
    const config: LocalConfig | null = await this.get('config')
    return config?.tenant?.url || undefined
  }

  async getAuthToken(): Promise<string | undefined> {
    const auth: IAuthStore | null = await this.get('auth')
    return auth?.accessToken || undefined
  }
}

const appPreferences: IAppPreferences = new AppPreferences()

const Boot = ({ app }) => {
  app.provide('appPreferences', appPreferences)
}

export default Boot

export { appPreferences }
